import { useMemo } from 'react';
import { useIsAutorizedUser } from 'store/features/auth/selectors';
import { useIsClient } from 'store/features/auth/selectors/user';

import { isEastTerritory } from 'common/utils/checkTerritory';
import { isFrameUser } from 'common/utils/frameUser';

export const useShowEBoxLocationButton = () => {
  const isAutorizedUser = useIsAutorizedUser();
  const isClient = useIsClient();

  return useMemo(() => !isEastTerritory && !isFrameUser && (isAutorizedUser && isClient), [
    isAutorizedUser,
    isClient
  ]);
};
